<template>
  <div class="bindAppPage">
    <wx-open-launch-weapp ref="launchBtnRef" id="launch-btn" username="gh_b6156951aeb6"
      :path="`/pages/index/index.html?p=loginByScanCode&t=unneedlogin&collegeId=${collegeId}&mpOpenid=${openid}`">
      <script type="text/wxtag-template">
        <button style="line-height: 44px;background-color: #5e4fff;text-align: center;color: white;
        border:none;padding: 0 40px; font-size: 14px;border-radius: 2px; height: 44px;margin: 0 auto;display: block;;position: relative
        ">点我打开小程序，完善个人简历！</button>
      </script>
    </wx-open-launch-weapp>
    <div v-if="isWeixinOpen === 1">您的微信版本较低无法拉起小程序，请在小程序搜索“工作啦”进入。</div>
  </div>
</template>

<script>
const wx = require('weixin-js-sdk')
export default {
  name: 'HelloWorld',
  data() {
    return {
      collegeId: '',
      openid: '',
      isWeixinOpen: 0
    }
  },
  created() {
    const { openid, collegeId, collegeid } = this.$route.query
    this.collegeId = collegeId || collegeid
    if (!openid) { this.toMpRedirect() }
    this.openid = openid
    this.toast.success('授权成功')
    this.xcx()
  },
  methods: {
    toMpRedirect() {
      window.location.href = `http://wx.goworkla.cn/mp/redirect?collegeid=${this.collegeId}&v=${Date.now()}&redirect_uri=${encodeURIComponent('http://wx.talent.goworkla.cn/#/bindApp')}`
    },
    xcx() {
      const ua = window.navigator.userAgent.toLowerCase()
      // 微信内核判断
      if (ua.indexOf('micromessenger') === -1) {
        this.isWeixinOpen = 1
      }
      const wechat = navigator.userAgent.match(/MicroMessenger\/([\d.]+)/i)
      if (!wechat) return
      const judgewechat = wechat[1].split('.')
      if (judgewechat[0] < 7) return
      if (judgewechat[1] < 0) return
      if (judgewechat[2] < 12) {
        this.isWeixinOpen = 2
        return
      }
      this.$api.getWechatInfo({
        collegeid: 'wechatofficial0000talent',
        url: encodeURIComponent(location.href.split('#')[0]),
        type: 'talentservice'
      }).then((res) => {
        if (!res) {
          this.isWeixinOpen = 2
          return
        }
        // 通过config接口注入 权限验证配置并申请所需开放标签
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
          appId: res.AppId, // 必填，公众号的唯一标识
          timestamp: res.Timestamp, // 必填，生成签名的时间戳
          nonceStr: res.NonceStr, // 必填，生成签名的随机串
          signature: res.Signature, // 必填，签名
          jsApiList: ['wx-open-launch-weapp'], // 必填，需要使用的JS接口列表
          openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app'],
        })
        this.isWeixinOpen = 2
        wx.ready(function () { })
        wx.error(function (res) { console.log('error', res) })
      })
    }
  }
}
</script>

<style scoped>
.bindAppPage {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/bindApp.vue